// DS1.10
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useCallback } from 'react';
import c from 'classnames';
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import SimpleTooltipContent from '../../SimpleTooltipContent';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import PopoverWrapper from '../../../popper/PopoverWrapper';
import s from './SimpleTooltip.scss';
const SimpleTooltip = (_param)=>{
    var { text , children , prefix , postfix , width , forceVisible =false , className  } = _param, rest = _object_without_properties(_param, [
        "text",
        "children",
        "prefix",
        "postfix",
        "width",
        "forceVisible",
        "className"
    ]);
    const { isVisible , onClick , onMouseEnter , onMouseLeave , onClose  } = usePopoverOnInteraction({
        listenOnClicks: true,
        listenOnHover: true
    });
    const reverseTheme = useReverseTheme();
    const renderPopover = useCallback(({ effectivePlacement , effectiveSecondaryPlacement , rootRef , arrowRef , contentStyle , arrowStyle , contentAttributes , arrowAttributes , updatePositioning ,  })=>/*#__PURE__*/ React.createElement(PopoverWrapper, {
            contentClassName: s['popover-wrapper'],
            width: width,
            onClickOutside: onClose,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            effectivePlacement: effectivePlacement,
            effectiveSecondaryPlacement: effectiveSecondaryPlacement,
            rootRef: rootRef,
            arrowRef: arrowRef,
            contentStyle: contentStyle,
            arrowStyle: arrowStyle,
            contentAttributes: contentAttributes,
            arrowAttributes: arrowAttributes,
            updatePositioning: updatePositioning,
            forceTheme: reverseTheme
        }, /*#__PURE__*/ React.createElement(SimpleTooltipContent, {
            prefix: prefix,
            postfix: postfix
        }, text)), [
        width,
        text,
        prefix,
        postfix,
        onMouseEnter,
        onMouseLeave,
        onClose,
        reverseTheme, 
    ]);
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, _extends({
        isVisible: isVisible || forceVisible,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        className: c(s['root'], className),
        renderPopover: renderPopover
    }, rest), children);
};
SimpleTooltip.displayName = 'SimpleTooltip';
export default SimpleTooltip;
